import React from "react";
import { Box, Typography } from "@mui/material";
import { useCart } from "../../context/cart-context";
import { CheckCard } from "./CheckCard";

import { ReactComponent as LockIcon } from "../../static/svg/lock.svg";
import StripeButtonComponent from "./StripeButtonComponent";

export const CheckoutOrder = () => {
  const { total } = useCart();
  const shippingFee = Number(process.env.REACT_APP_SHIPPING_FEE) || 12;
  const grandTotal = Number(total) + shippingFee;

  return (
    <React.Fragment>
      <Box className="py-2 px-10">
        <Typography
          variant="h3"
          fontSize={{ xs: "15px", sm: "20px" }}
          lineHeight={{ xs: "200%", sm: "180%" }}
          letterSpacing={"0.02em"}
          className=" capitalize"
          color={"secondary"}
        >
          Your Order
        </Typography>
        <CheckCard text={"Subtotal"} value={`£${total}`} />
        <CheckCard text={"Shipping fee"} value={`£${shippingFee}`} />
        <hr className=" hidden md:block w-full border-[1px] border-grey-100 mb-8 border-dotted" />

        <CheckCard text={"Total"} value={` £${grandTotal}`} />

        {/* <CustomButton
          type="submit"
          // form="add-member-form"
          // loading={true}
          // sx={{ width: "220px", height: "55px" }}
          color="secondary"
          className="text-sm"
          // onClick={handleCheckoutRoute}
          // to={"/checkout"}
          fullWidth
        >
          Make Payment
        </CustomButton> */}
        {/* <PayPalButtonComponent totalPrice={grandTotal} items={cart} /> */}
        <StripeButtonComponent totalPrice={grandTotal} />

        <Box className="flex gap-4 place-content-center pt-0 items-center">
          <LockIcon className="w-4 h-4" />
          <Typography
            variant="body"
            fontSize={{ xs: "12px", sm: "13px", md: "13px" }}
            lineHeight={{ xs: "200%", sm: "180%" }}
            letterSpacing={"0.02em"}
            className="opacity-90"
            color={"primary"}
          >
            Secure Checkout
          </Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
};
